<template>
    <div>
        <b-card>
            <dashboard-calendar></dashboard-calendar>
        </b-card>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {}
        },
    }
    </script>